"use client";

import * as React from "react";
import { Star, Loader2 } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface Review {
  text: string;
  author_name: string;
  profile_photo_url: string;
  rating: number;
}
export default function RealStoriesFromSatisfiedUsers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [reviews, setReviews] = React.useState<Review[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  React.useEffect(() => {
    const fetchGoogleReviews = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch('/api/reviews');
        if (!response.ok) {
          throw new Error("Failed to fetch reviews");
        }
        const data = await response.json();
        const rawReviews = Array.isArray(data) ? data : data.reviews || [];
        const transformedReviews: Review[] = rawReviews.map((rev: any) => ({
          text: rev.text || "",
          author_name: rev.author_name || "Anonymer Kunde",
          profile_photo_url: rev.profile_photo_url || "",
          rating: typeof rev.rating === 'number' ? rev.rating : 5
        }));
        setReviews(transformedReviews);
      } catch (err) {
        console.error("Error fetching Google reviews:", err);
        setError("Bewertungen konnten nicht geladen werden.");
      } finally {
        setLoading(false);
      }
    };
    fetchGoogleReviews();
  }, []);
  return;
}